export class UtilFunctions {

    static calculateLastYears(threshold: number[], numYears: number): number[] {
        const result: number[] = [];
        const now = new Date();
        const m = now.getMonth();
        const d = now.getDay();
        const y = now.getFullYear();

        let first = y;
        if (m > threshold[0] || (m === threshold[0] && d >= threshold[1])) {
            ++first;
        }

        for (let i = 0; i < numYears; i++) {
            result.push(first - i);
        }

        return result;
    }

    static calculateNextYears(threshold: number[], numYears: number): number[] {
        const result: number[] = [];
        const now = new Date();
        const m = now.getMonth();
        const d = now.getDate();
        const y = now.getFullYear();

        let first = y;
        let n = numYears;

        if (m > threshold[0] || (m === threshold[0] && d >= threshold[1])) {
            n = n + 1;
        }

        for (let i = 0; i < n; i++) {
            result.push(first + i);
        }

        return result;
    }

    static getRecentYear(): number {
        return new Date().getFullYear();
    }

    static yearsToDate(futureYears: string) {
        const date = new Date();
        const numYears = parseInt(futureYears);
        date.setDate(date.getDate() + numYears * 365);

        return date;
    }

}
